import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from './http.service';
import { DivisionMst } from '../../../interfaces/masters/division-mst';

@Injectable()
export class DivisionMstApi {

  constructor(private api: HttpService) { }

  list(url: string): Observable<any> {
    return this.api.get(url, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

  getById(url: string): Observable<DivisionMst> {
    return this.api.get(url, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

  add(url: string, data: DivisionMst): Observable<any> {
    return this.api.post(url, data, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

  update(url: string, data: DivisionMst): Observable<any> {
    return this.api.put(url, data, {
      headers: {
        'Accept': 'application/vnd.ezovion.hateoas+json',
        'Content-Type': 'application/json',
      },
    });
  }

}
